import type { HTMLAttributes, ReactNode } from 'react'

type HeadingSize = 'sm' | 'md' | 'lg' | 'xl'

interface HeadingProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode
  size?: HeadingSize
}

export const Heading = ({ children, size = 'xl', className = '', ...props }: HeadingProps) => {
  const headingSize = () => {
    switch (size) {
      case 'sm':
        return 'ap:text-sm ap:leading-5 ap:font-semibold'
      case 'md':
        return 'ap:text-[16px] ap:leading-6 ap:font-semibold'
      case 'lg':
        return 'ap:text-lg ap:leading-7 ap:font-semibold '
      default:
        return 'ap:text-xl ap:leading-8 ap:font-semibold'
    }
  }

  return (
    <p className={` ${headingSize()} ${className}`.trim()} {...props}>
      {children}
    </p>
  )
}
